async function getAdSettings() {
  const res = await window.axios.get('/api/v1/admin/ads/setting');
  return res.data;
}

async function setAdSettings(params) {
  const res = await window.axios.put('/api/v1/admin/ads/setting', params);
  return res.data;
}

module.exports = { getAdSettings, setAdSettings };
